// extracted by mini-css-extract-plugin
export default {"parText":"LeftSkewPar_parText__tkzpA"};